import { render } from "./HeroLiquidationStatus.vue?vue&type=template&id=316f4cd0&scoped=true"
import script from "./HeroLiquidationStatus.vue?vue&type=script&lang=js"
export * from "./HeroLiquidationStatus.vue?vue&type=script&lang=js"

import "./HeroLiquidationStatus.vue?vue&type=style&index=0&id=316f4cd0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316f4cd0"]])

export default __exports__